<template>
    <main>
       <div class="container-fluid">
            <div class="row">
               <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                      <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Requests for Executive Director</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/edrequests/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control"
                                v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod"
                                @openAction="openAction" :filtersearch="filter"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/EdRequests/MenuList.vue";
    import lang from "@/views/modules/EdRequests/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";
    import CustomSearch from "@/views/modules/EdRequests/SearchView.vue";

    export default {
        name: "new-ed-requets",
        components: {
            breadcrumbs,
            GenericList,
            CustomSearch,
        },
        data() {
            return {
                generic:true,
                isActive: false,
                filter: false,
                metaList: [
                    {
                        label: lang.LBL_REQUEST_NO,
                        link: true,
                        moduleName: 'EdRequests',
                        routePath: 'edrequests',
                        linkOtherModule:false,
                        isSort: true,
                        field_name: 'request_no'
                    
                    },
                    {
                        label: lang.LBL_REQUEST_BY,
                        link: false,
                        moduleName: 'EdRequests',
                        routePath: 'edrequests',
                        linkOtherModule:false,
                        relRef:'edrequests_users',
                        isSort: true,
                        field_name: 'name'
                    
                    },
                    {
                        label: lang.LBL_REQUEST_TO,
                        link: false,
                        moduleName: 'EdRequests',
                        routePath: 'edrequests',
                        linkOtherModule:false,
                        relRef:'edrequests_ assigned_users',
                        isSort: true,
                        field_name: 'name__assigned'
                    
                    },
                    {
                        label: lang.LBL_DESCRIPTION,
                        link: false,
                        linkOtherModule:false,
                        isSort: true,
                        field_name: 'description'
                    },
                    {
                        label: lang.LBL_REQUEST_STATUS,
                        link: false,
                        linkOtherModule:false,
                        isSort: true,
                        field_name: 'status'
                    },
                ],
                columns: ['request_no', 'created_by_name', 'assigned_user_name', 'description', 'status'],
            }
        },
        mounted() {
            this.childMethod();
            this.$emit('MetaView', 'Awesome')
        },
        methods: {
            childMethod(search = '') {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns, search);
                } else {
                    if (search != '') {
                        this.$refs.loadCustom.getProducts(search);
                    }
                }
            },

            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }
</script>